import { PolicyRequirement } from '@forgerock/javascript-sdk';

export const parseFailedPolicies = (failedPolicies: PolicyRequirement[]): PolicyRequirement[] => failedPolicies.map(parseFailedPolicy);

const parseFailedPolicy = (failedPolicy: PolicyRequirement): PolicyRequirement => {
  try {
    return JSON.parse(failedPolicy + '');
  } catch (error) {
    // If parsing fails, return DEFAULT
    return { policyRequirement: 'DEFAULT' } as PolicyRequirement;
  }
};
